
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/box/users/[adviserName]",
      function () {
        return require("private-next-pages/box/users/[adviserName].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/box/users/[adviserName]"])
      });
    }
  